// Hub member data (Phase 2 Stage 1)

export const MEMBER_TYPES = [
  "Founder / Co-Founder",
  "Business Owner",
  "Startup Representative",
  "Freelancer",
  "Consultant",
  "Agency Representative",
  "Service Provider",
  "Investor",
  "Mentor / Advisor",
  "Incubator / Accelerator Representative",
  "University / Educational Institution",
  "Corporate Representative",
  "Growth Partner",
  "Other",
];

export const BUSINESS_TYPES = new Set([
  "Founder / Co-Founder",
  "Business Owner",
  "Startup Representative",
  "Agency Representative",
  "Service Provider",
  "Corporate Representative",
]);

export const PROFESSIONAL_TYPES = new Set([
  "Freelancer", "Consultant", "Mentor / Advisor", "Growth Partner",
]);

export const INVESTOR_TYPES = new Set(["Investor"]);

export const COMPANY_SIZES = ["Solo", "2–10", "11–50", "51–200", "201–500", "500+"];
export const BUSINESS_STAGES = ["Idea", "Pre-launch", "Early stage", "Revenue generating", "Growth", "Established"];
export const INDUSTRIES = [
  "Technology", "Marketing", "E-commerce", "Finance", "Healthcare", "Education",
  "Manufacturing", "Consulting", "Media", "Real Estate", "Hospitality", "Logistics",
  "Retail", "Legal", "Energy", "Other",
];
export const AVAILABILITY = ["Available now", "Available in a few weeks", "Selective", "Not currently available"];
export const INVESTOR_KINDS = ["Angel Investor", "VC", "Family Office", "Corporate Investor", "Syndicate", "Other"];
export const INVESTMENT_STAGES = ["Pre-seed", "Seed", "Series A", "Series B", "Series C+", "Growth"];
export const TICKET_RANGES = ["Under $25k", "$25k – $100k", "$100k – $500k", "$500k – $2M", "$2M – $10M", "$10M+"];
export const YEARS_EXPERIENCE = ["<1 year", "1–3", "3–5", "5–10", "10–20", "20+"];

export const OFFERS = [
  "Products", "Professional Services", "Expertise", "Mentorship", "Investment",
  "Business Referrals", "Cross-Selling", "Partnership Opportunities", "Distribution",
  "Technology", "Talent", "Resources / Knowledge", "Other",
];

export const EVENT_TYPES = [
  "Conference", "Workshop", "Webinar", "Expo", "Investor Event",
  "Professional Meetup", "Seminar", "Panel Discussion", "Training", "Other",
];

export const EVENT_FORMATS = ["Online", "Physical", "Hybrid"];

export const EVENT_CATEGORIES = [
  "Business Networking", "Marketing", "Sales", "Product", "Technology",
  "AI", "Operations", "Finance", "Fundraising", "Trade", "Investment",
  "HR & Talent", "Legal", "Design", "Cross-Border", "Other",
];

export const LOOKING_FOR = [
  "Customers", "Business Partners", "Cross-Selling Partners", "Service Providers",
  "Investors / Funding", "Startups to Invest In", "Mentors / Advisors", "Talent",
  "Freelancers", "Vendors", "Distribution Partners", "Technology Partners",
  "Professional Events", "Business Knowledge", "Networking", "Other",
];
